import React, { useMemo, useState } from "react";
import {
  Modal,
  View,
  Text,
  TextInput,
  ScrollView,
  TouchableOpacity,
  Image,
} from "react-native";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { useNavigation, StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import { CommonButton } from "../../common/CommonButton";
import Separator from "../../Components/Separator";
import PurchaseSuccessModal from "../../screens/Auth/WebScreens/Modals/PurchaseSuccessModal";
import { ticketEvent } from "../../services/eventsAPI";
import StreamerViewComponent from "../notification-common-components/StreamerViewComponent";
import DescriptionScrollView from "../notification-common-components/DescriptionScrollView";
import { useLiveStream } from "../../context/LiveStreamContext";
import { AppScreens } from "../../screens/Utility/AppScreens";

const LiveStreamBuyTicketModal = () => {
  const {
    audienceData,
    userData,
    closeBuyTicketModal,
    loginData,
    setAudienceData,
  } = useLiveStream();

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();

  const [promotionCode, setPromotionCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const eventDetails = audienceData.eventDetails;
  const ticketPrice = eventDetails?.ticketPrice || 0;
  const remainingBalance =
    userData?.tokens && ticketPrice
      ? Number(userData.tokens) - Number(ticketPrice)
      : 0;

  const isBalanceSufficient = remainingBalance >= 0;

  const formattedDate = useMemo(() => {
    if (!eventDetails.startDateTime) return "No date available";
    return format(new Date(eventDetails.startDateTime), "do MMM, h:mmaaa");
  }, [eventDetails.startDateTime]);

  const handlePurchase = async () => {
    setIsSubmitting(true);

    const bodyParams = {
      accessToken: loginData?.accessToken,
      eventID: eventDetails.eventID,
      newAttendeeIDs: [userData?.userID],
      token: Number(ticketPrice),
    };

    try {
      const response = await ticketEvent(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        toast.success(response.body?.message || "Purchase successful!");
        setAudienceData((prev) => ({
          ...prev,
          eventDetails: {
            ...prev.eventDetails,
            attendeeIDs: [
              ...(prev.eventDetails?.attendeeIDs || []),
              userData?.userID,
            ],
          },
        }));
        closeBuyTicketModal(true);
      } else {
        toast.error(response.body?.error || "Failed to purchase ticket.");
      }
    } catch (error) {
      toast.error("An error occurred while purchasing the ticket.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal transparent={true} visible={true}>
      <View style={styles.container}>
        <ScrollView style={styles.mainView}>
          <View style={styles.allView}>
            <View style={styles.wrraperView}>
              <Text style={AppFontStyle.BOLD_ANYBODY_32}>Buy Tickets</Text>
            </View>

            <View
              style={{
                height: 1,

                backgroundColor: AppColors.grayColor_333333,
              }}
            />

            <View style={styles.deviceDirection}>
              <View style={{ flex: 1 }}>
                <View
                  style={{
                    flexDirection: "row",
                    marginVertical: 15,
                    alignItems: "center",
                  }}
                >
                  <Text style={[AppFontStyle.BOLD_ANYBODY_16, { flex: 1 }]}>
                    {eventDetails?.title}
                  </Text>
                  <View
                    style={{
                      paddingHorizontal: 18,
                      paddingVertical: 5,
                      borderRadius: 7,
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                    }}
                  >
                    <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                      {formattedDate}
                    </Text>
                  </View>
                </View>
                <StreamerViewComponent
                  styles={styles}
                  participants={audienceData.participantDetails}
                  attendees={eventDetails?.attendeeIDs}
                />
                <DescriptionScrollView styles={styles} details={eventDetails} />
              </View>

              <View style={{ flex: 1 }}>
                <View
                  style={{
                    backgroundColor: AppColors.grayColor_333333,
                    borderRadius: 10,
                    paddingHorizontal: 7,
                    paddingVertical: 10,
                    marginTop: 15,
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.gray_C3C3C3 },
                    ]}
                  >
                    Your Token Balance
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.white, marginTop: 15 },
                    ]}
                  >
                    {userData?.tokens || 0}
                  </Text>
                  <CommonButton
                    title="Top-Up"
                    onTap={() => {
                      closeBuyTicketModal(false);
                      navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                          eventID: eventDetails.eventID,
                        });
                    }}
                    buttonStyle={styles.btnTopUpStyle}
                    textStyle={AppFontStyle.BOLD_ANYBODY_12}
                  />
                </View>

                <TextInput
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    {
                      backgroundColor: AppColors.grayColor_333333,
                      borderRadius: 10,
                      paddingHorizontal: 7,
                      paddingVertical: 20,
                      marginTop: 5,
                    },
                  ]}
                  placeholder="Enter Promotion Code"
                  placeholderTextColor={AppColors.gray_C3C3C3}
                  value={promotionCode}
                  onChangeText={setPromotionCode}
                />

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.gray_C3C3C3, marginTop: 25 },
                    ]}
                  >
                    Ticket Price
                  </Text>

                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.white, marginTop: 25 },
                    ]}
                  >
                    {ticketPrice}
                  </Text>
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.gray_C3C3C3, marginTop: 25 },
                    ]}
                  >
                    Balance
                  </Text>

                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.white, marginTop: 25 },
                    ]}
                  >
                    {userData?.tokens}
                  </Text>
                </View>

                <View style={{ marginTop: 13 }}>
                  <Separator
                    color={AppColors.grayColor_333333}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.gray_C3C3C3, marginTop: 25 },
                    ]}
                  >
                    Remaining balance
                  </Text>

                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.white, marginTop: 25 },
                    ]}
                  >
                    {isBalanceSufficient
                      ? `${remainingBalance}`
                      : "Insufficient Balance - Recharge Required"}
                  </Text>
                </View>

                <CommonButton
                  title="Purchase"
                  onTap={handlePurchase}
                  disabled={!isBalanceSufficient || isSubmitting}
                  buttonStyle={styles.btnSignUpStyle}
                  textStyle={AppFontStyle.BOLD_ANYBODY_12}
                />
              </View>
            </View>
          </View>
        </ScrollView>
      </View>
    </Modal>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    },
    mainView: {
      width: "50%",
      marginHorizontal: 40,
      marginVertical: 100,
      alignSelf: "center",
      height: "100%",
    },
    allView: {
      borderRadius: 10,
      backgroundColor: AppColors.gray_1E1E1E,
      paddingTop: 10,
      paddingHorizontal: 30,
      paddingBottom: 30,
      height: "100%",
    },
    wrraperView: {
      flexDirection: "row",
      paddingVertical: 20,
    },
    streamerView: {
      backgroundColor: AppColors.grayColor_333333,
      borderRadius: 10,
    },
    streamViewStyle: {
      width: "100%",
      borderRadius: 10,
      paddingVertical: 9,
      paddingHorizontal: 11,
      gap: 10,
    },
    priceView: {
      backgroundColor: AppColors.grayColor_333333,
      marginTop: 5,
      borderRadius: 10,
      width: "50%",
    },
    detailTextStyle: {
      height: 100,
    },
    btnTopUpStyle: {
      marginVertical: 10,
      paddingVertical: 0,
      paddingHorizontal: 20,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 30,
      borderRadius: 7,
      alignSelf: "flex-end",
      // top: 10,
    },
    btnSignUpStyle: {
      marginVertical: 10,
      paddingVertical: 0,
      paddingHorizontal: 20,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      height: 30,
      borderRadius: 7,
      alignSelf: "center",
      top: 10,
    },
    textInput: {
      paddingVertical: 12,
      paddingHorizontal: 60,
      backgroundColor: AppColors.black,
      margin: 5,
      borderRadius: 10,
    },
    deviceDirection: {
      flexDirection: "row",
    },
    btnGetTicketStyle: {
      paddingVertical: 0,
      paddingHorizontal: 15,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      flexGrow: 1,
      height: 40,
      borderRadius: 10,
    },
    playersView: {
      flexDirection: "row",
      gap: 10,
      justifyContent: "space-evenly",
    },
    playerView: {
      borderRadius: 12,
      alignItems: "center",
    },
    playerImg: {
      height: 104,
      width: 93,

      marginVertical: 10,
    },
    vsImage: {
      width: 50,
      height: 100,
      marginVertical: 10,
    },
  },

  {
    [DEVICE_SIZES.MD]: {
      mainView: {
        borderRadius: 10,
        width: "70%",
        marginHorizontal: 40,
        marginVertical: 75,
      },
      allView: {
        padding: 10,
      },
      streamViewStyle: {
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      textInput: {
        paddingVertical: 12,
        paddingHorizontal: 60,
        backgroundColor: AppColors.black,
        margin: 5,
        borderRadius: 10,
      },
      wrraperView: {
        flexDirection: "row",
        paddingVertical: 20,
      },
      streamerView: {
        backgroundColor: AppColors.grayColor_333333,
        borderRadius: 10,
      },
      priceView: {
        backgroundColor: AppColors.grayColor_333333,
        marginTop: 5,
        borderRadius: 10,
        width: "55%",
      },
      btnTopUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "flex-end",
      },
      btnSignUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "center",
        top: 10,
      },
      playersView: {
        flexDirection: "row",
        gap: 5,
      },
      playerImg: {
        height: 51,
        width: 51,
        marginVertical: 10,
      },
      vsImage: {
        width: 70,
        height: 70,
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.LG]: {
      mainView: {
        width: "60%",
        marginHorizontal: 40,
        marginVertical: 65,
        alignSelf: "center",
      },
      allView: {
        padding: 30,
      },
      streamViewStyle: {
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      wrraperView: {
        flexDirection: "row",

        paddingVertical: 20,
      },
      textInput: {
        paddingVertical: 12,
        paddingHorizontal: 60,
        backgroundColor: AppColors.black,
        margin: 5,
        borderRadius: 10,
      },
      streamerView: {
        backgroundColor: AppColors.grayColor_333333,
        borderRadius: 10,
      },
      priceView: {
        backgroundColor: AppColors.grayColor_333333,
        marginTop: 5,
        borderRadius: 10,
        width: "52%",
      },
      btnTopUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "flex-end",
      },
      btnSignUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "center",
        top: 10,
      },
      playersView: {
        flexDirection: "row",
        gap: 5,
      },
      vsImage: {
        width: 50,
        height: 100,
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "80%",
        marginHorizontal: 40,
        marginVertical: 90,
        alignSelf: "center",
      },
      allView: {
        padding: 10,

        paddingHorizontal: 10,
      },
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      detailTextStyle: {
        height: 100,
      },
      wrraperView: {
        flexDirection: "row",
        paddingVertical: 20,
      },
      streamViewStyle: {
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      streamerView: {
        backgroundColor: AppColors.grayColor_333333,

        borderRadius: 10,
        height: "20%",
      },
      textInput: {
        paddingVertical: 12,
        paddingHorizontal: 60,
        backgroundColor: AppColors.black,
        margin: 5,
        borderRadius: 10,
      },
      priceView: {
        backgroundColor: AppColors.grayColor_333333,
        marginTop: 5,
        borderRadius: 10,
        width: "55%",
      },
      playerImg: {
        height: 96,
        width: 80,
      },
      btnTopUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "flex-end",
      },
      btnSignUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "center",
        top: 10,
      },
      playersView: {
        flexDirection: "row",
        gap: 10,
      },
      vsImage: {
        width: 50,
        height: 100,
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      detailTextStyle: {
        height: 100,
      },
      mainView: {
        width: "95%",
        marginHorizontal: 40,
        marginVertical: 40,
        alignSelf: "center",
      },
      allView: {
        padding: 10,
        borderRadius: 10,
        paddingHorizontal: 10,
      },
      wrraperView: {
        flexDirection: "row",

        paddingVertical: 10,
      },
      playerImg: {
        height: 96,
        width: 80,
      },
      streamerView: {
        backgroundColor: AppColors.grayColor_333333,
        borderRadius: 10,
      },
      streamViewStyle: {
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      playersView: {
        flexDirection: "row",
        gap: 10,
      },
      priceView: {
        backgroundColor: AppColors.grayColor_333333,
        marginTop: 5,
        borderRadius: 10,
        width: "40%",
      },
      textInput: {
        paddingVertical: 12,
        paddingHorizontal: 60,
        backgroundColor: AppColors.black,
        margin: 5,
        borderRadius: 10,
      },
      btnTopUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "flex-end",
      },
      btnSignUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "center",
        top: 10,
      },
      deviceDirection: {
        flexDirection: "column",
      },
      vsImage: {
        width: 50,
        height: 100,
        marginVertical: 10,
      },
    },
  }
);

export default LiveStreamBuyTicketModal;
